import React, { useRef } from "react";
import styles from "./inputFile.module.css"
import Button from "../Button";
import { MdOutlineFileUpload } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { getIconByExtensionFile } from "../../../utils/utils";

const InputFile = ({ value = [], accept = "", onChange = () => { }, theme, multiple = false, disabled = false, placeholder = "Adicionar arquivo", className = "", buttonClassName = "", buttonContent, buttonVariant = "primary", title }) => {
    const refInput = useRef()

    const handleChangeValues = (e) => {
        if (multiple) {
            const newFiles = [...e.target.files]
            const newValue = [...value]
            newFiles?.forEach(file => {
                const [fileExists] = newValue?.filter(value => value.name === file.name && value.size === file.size && value.lastModified === file.lastModified)
                if (!fileExists) {
                    newValue.push(file)
                }
            })
            onChange(newValue)
        } else {
            const newFiles = [...e.target.files]
            onChange(newFiles)
        }
    }

    const handleRemoveFile = (index) => {
        const newValue = [...value]
        newValue.splice(index, 1)
        onChange(newValue)
    }

    return (
        <>
            {value.length > 0 && <div className={styles.listFiles}>
                {value.map((file, index) => (
                    <div className={styles.file} key={index}>
                        {getIconByExtensionFile(file.name)}
                        <span>{file.name}</span>
                        <div className={styles.remove} onClick={() => handleRemoveFile(index)}>
                            <IoIosCloseCircleOutline />
                        </div>
                    </div>
                ))}
            </div>}
            <div className={`${styles.input} ${styles[theme]} ${className}`.trim()}>
                <Button type="button" variant={buttonVariant} className={buttonClassName} fullWidth={!buttonClassName} onClick={() => refInput.current.click()} disabled={disabled} title={title}>
                    {buttonContent || <><span>{placeholder}</span><MdOutlineFileUpload /></>}
                </Button>
                <input type="file" value={[]} onChange={handleChangeValues} id="inputFile" multiple={multiple} ref={refInput} accept={accept} disabled={disabled} />
            </div>
        </>
    )
}

export default InputFile
